// VariancePanel.js
import React, { useMemo } from 'react'
import { pairLineItems } from './lineVariance'

const fmt = (v) => '$' + (Number(v) || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })

const deltaCell = (changed, fromV, toV, isMoney) => (
  <span style={{ color: changed ? 'var(--risk)' : 'var(--ink-3)', fontWeight: changed ? 600 : 400 }}>
    {isMoney ? fmt(fromV) : fromV} {changed ? '→ ' + (isMoney ? fmt(toV) : toV) : ''}
  </span>
)

export default function VariancePanel ({ invoiceLineItems, quoteLineItems }) {
  const { pairs, addedOnInvoice, droppedFromQuote } = useMemo(
    () => pairLineItems(invoiceLineItems || [], quoteLineItems || []),
    [invoiceLineItems, quoteLineItems]
  )

  const changedCount = pairs.filter(p => p.quantityChanged || p.unitPriceChanged).length

  return (
    <div className="hmi-panel" style={{ marginTop: 12 }}>
      <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 8 }}>
        Invoice vs. Quote — {changedCount} changed, {addedOnInvoice.length} added, {droppedFromQuote.length} dropped
      </div>
      <table className="hmi-table">
        <thead>
          <tr>
            <th>Description (invoice)</th>
            <th>Match</th>
            <th style={{ textAlign: 'right' }}>Qty (quote → invoice)</th>
            <th style={{ textAlign: 'right' }}>Unit Price (quote → invoice)</th>
          </tr>
        </thead>
        <tbody>
          {pairs.map((p, i) => (
            <tr key={'p' + i} style={(p.quantityChanged || p.unitPriceChanged) ? { background: 'var(--warn-tint)' } : undefined}>
              <td style={{ fontSize: 12.5 }}>{p.invoiceLine.description}</td>
              <td style={{ fontSize: 11, color: 'var(--ink-3)' }}>{p.matchType}</td>
              <td className="num">{deltaCell(p.quantityChanged, p.quoteLine.quantity, p.invoiceLine.quantity, false)}</td>
              <td className="num">{deltaCell(p.unitPriceChanged, p.quoteLine.unitPrice, p.invoiceLine.unitPrice, true)}</td>
            </tr>
          ))}
          {addedOnInvoice.map((li, i) => (
            <tr key={'a' + i} style={{ background: 'var(--info-tint)' }}>
              <td style={{ fontSize: 12.5 }}>{li.description}</td>
              <td colSpan={3} style={{ fontSize: 11, color: 'var(--info)' }}>New on invoice — not on quote</td>
            </tr>
          ))}
          {droppedFromQuote.map((li, i) => (
            <tr key={'d' + i} style={{ background: 'var(--bg-panel-alt)' }}>
              <td style={{ fontSize: 12.5, color: 'var(--ink-3)' }}>{li.description}</td>
              <td colSpan={3} style={{ fontSize: 11, color: 'var(--ink-3)' }}>On quote — not invoiced</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
